import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './i18n';
import store from './redux/store';
import { enStyle } from './style/enStyle';
import { faStyle } from './style/faStyle';

let lang = localStorage.getItem("lang");

if (lang === "fa" || lang === "ar") {
  faStyle()
} else if (lang === "en") {
  enStyle()
}

ReactDOM.render(
  <Provider store={store}><App /></Provider>,
  document.getElementById('root')
);
